import request from '@/utils/request'

export function userMyAuth () {
  return request({
    url: '/amrep/user/myAuth',
    method: 'get'
  })
}

export function userItems (params) {
  return request({
    url: '/amrep/user/items',
    method: 'get',
    params
  })
}

export function userItemsSearchAll () {
  return request({
    url: '/amrep/user/itemsSearchAll',
    method: 'get'
  })
}

export function userOpen (data) {
  return request({
    url: '/amrep/user/open',
    method: 'put',
    data
  })
}

export function userClose (data) {
  return request({
    url: '/amrep/user/close',
    method: 'put',
    data
  })
}

export function userUnbundling (data) {
  return request({
    url: '/amrep/user/unbundling',
    method: 'put',
    data
  })
}

export function userDetails (data) {
  return request({
    url: '/amrep/user/details/' + data.id,
    method: 'get'
  })
}

export function userChangeAuth (data) {
  return request({
    url: '/amrep/user/changeAuth/' + data.emp_id,
    method: 'put',
    data
  })
}

export function adminChangePassword (data) {
  return request({
    url: '/amrep/user/adminChangePassword',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js